import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TextBlock from './TextBlock';

import './TextImageBlock.scss';

const TextImageBlock = ({
  imagePosition,
  imageSrc,
  imageDescription,
  imageStyle,
  titleTag,
  title,
  content,
  alignTo,
  titleSize,
  contentSize,
  textStyle,
  hasMaxWidth
}) => {
  const containerClass = classNames('text-image-block', {
    'text-image-block--max-width': hasMaxWidth,
    'text-image-block--left-image': imagePosition === 'left'
  });

  const textClass = classNames(
    'text-image-block__text',
    'text-image-block__side',
    {
      'text-image-block__text--left-image': imagePosition === 'left'
    }
  );

  const imageClass = classNames('text-image-block__image');

  return (
    <div className={containerClass}>
      <div className={textClass}>
        <TextBlock
          title={title}
          content={content}
          alignTo={alignTo}
          titleSize={titleSize}
          titleTag={titleTag}
          contentSize={contentSize}
          style={textStyle}
        />
      </div>
      <img
        className={imageClass}
        src={imageSrc}
        alt={imageDescription}
        style={imageStyle}
      />
    </div>
  );
};

TextImageBlock.propTypes = {
  imagePosition: PropTypes.oneOf(['left', 'right']),
  imageSrc: PropTypes.string.isRequired,
  imageDescription: PropTypes.string.isRequired,
  imageStyle: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  alignTo: PropTypes.oneOf(['right', 'left', 'center']),
  titleSize: PropTypes.oneOf(['big', 'medium']),
  titleTag: PropTypes.string,
  contentSize: PropTypes.oneOf(['big', 'medium']),
  textStyle: PropTypes.string,
  hasMaxWidth: PropTypes.bool
};

TextImageBlock.defaultProps = {
  imagePosition: 'right',
  imageStyle: {},
  titleTag: 'h2',
  alignTo: 'center',
  titleSize: 'big',
  contentSize: 'medium',
  textStyle: {},
  hasMaxWidth: false
};

export default TextImageBlock;
